import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import PictureCard from "./Components/PictureCard";
import InformationCard from "./Components/InformationCard";
import AddressCard from "./Components/AddressCard";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import TableLoading from "../../Components/Loader/TableLoading";
import { API_BASE_URL } from "../../config/api";

export default function Information() {
  const navigate = useNavigate();
  const [accountData, setAccountData] = useState(null);
  const [accLoading, setAccLoading] = useState(true);
  const fetchAccountData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}auth/trader/info/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}auth/trader/info/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
      setAccLoading(false);
      localStorage.setItem("fn", data?.fn);
      localStorage.setItem("ln", data?.ln);
    } catch (error) {
      setAccLoading(false);
      console.error("Error fetching account data:", error);
    }
  };

  useEffect(() => {
    fetchAccountData();
  }, []);
  return (
    <LayoutPage
      activeIndex={12}
      navItems={["حساب کاربری"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["اطلاعات حساب", "امنیت حساب", "احراز هویت"]}
        hrefs={["/profile/information", "/profile/security", "/profile/kyc"]}
        activeIndex={0}
      />
      <div className="w-full h-fit flex flex-col items-center gap-5 min-h-0 overflow-y-auto">
        {!accLoading ? (
          <>
            <PictureCard accountData={accountData} />
            <InformationCard accountData={accountData} />
            <AddressCard accountData={accountData} />
          </>
        ) : (
          <div className="w-full flex justify-center items-center gap-2">
            <p className="text-[#808080]">در حال بارگذاری</p>
            <TableLoading className="text-[#808080]" />
          </div>
        )}
      </div>
    </LayoutPage>
  );
}
